import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { KeyValue } from '../../models/common';

export interface TagFilterData {
  title: string;
  excerpt: string;
}

@Component({
  selector: 'antera-lib-kanban-search-tag-filter-data',
  templateUrl: './kanban-search-tag-filter-data.component.html',
  styleUrls: ['./kanban-search-tag-filter-data.component.scss'],
})
export class KanbanSearchTagFilterDataComponent implements OnInit {
  @Input() tagFilterData: TagFilterData = { title: '', excerpt: '' };
  @Input() anteraFilterOptions: KeyValue[] = [];
  @Output() filterByTag = new EventEmitter<string[]>();

  anteraFilterForm = new FormControl();

  constructor() {}

  ngOnInit(): void {
    if (this.anteraFilterForm) {
      this.anteraFilterForm.valueChanges.subscribe((values) => {
        if (values) {
          this.filterByTag.emit(values);
        }
      });
    }
  }
}
